const hasSelectedTeaser = {
    title: 'Example JSON',
    expectedOutput: '132',
    initialDisplayedCode: `{
	"hasSelectedTeaser": true,
	"selectedTab": "combination",
	"stakes": [{
		"stake": 1,
		"type": "combination"
	},`,
    moreCode: `
	{
		"stake": 100,
		"type": "teaser"
	}],
	"selectedReward": {},
	"betOffers": [],
	"selectedOutcomes": [{
		"id": 100,
		"odds": 1100
	},
	{
		"id": 101,
		"odds": 1200
	}]
}`,
};

export default hasSelectedTeaser;
